import {
    ORDER_DELIV_CANCEL,
    ORDER_DELIV_COMPLETE,
    ORDER_DONE,
    ORDERS_UPDATE
} from "../../constants/action-types";

import initialState from "../initialState";

const orders = (state = initialState.orders, action) => {
    switch (action.type) {
        case ORDER_DELIV_CANCEL:
            if (state.ordersState === 2) { return state; }
            return { 
                ...state,
                orderData: action.payload,
                ordersState: 2 }

        case ORDER_DELIV_COMPLETE:
            if (state.ordersState === 1) { return state; }
            return { 
                ...state,
                orderData: action.payload,
                ordersState: 1 }

        case ORDER_DONE:
            return { ...state, ordersState:0 }

        case ORDERS_UPDATE:
            return {
                ...state,
                ordersDeliv: action.payload.delivery, 
                ordersState: 0,
                orders: action.payload.orders
            }

        default:
            return state;
    }
}

export default orders;


// WEBPACK FOOTER //
// ./src/store/reducers/orders.js